export default __webpack_public_path__ + "assets/images/cd21335e967fa98de3c0912f9560a36d.svg";